const AbstractItem = require('@/lib/Items/AbstractItem');
const ItemType = require('@/lib/Items/ItemType');
const { populate } = require('@/functions/objects');
const { toBool, toInt } = require('@/functions/transform');

class ItemOption extends AbstractItem {
    constructor(data = {}) {
        super();

        this.itemType = ItemType.ITEM_OPTION;

        this.showOnKitchenScreen = false;

        populate(this, data);
    }

    getHydrationMap() {
        return {
            ...super.getHydrationMap(),

            ID: {
                field: ['itemOptionID', 'itemID', 'ID'],
                transform: toInt,
            },
            showOnKitchenScreen: toBool,
        };
    }

    afterHydration(data = {}) {
        // This looks redundant, but it wasn't getting called without this.
        super.afterHydration(data);
    }
}

module.exports = ItemOption;
